module.exports = __webpack_public_path__ + "static/media/shdocvw_262.d6c07b02.ico";